import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontIcon } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Alert } from '@bingads-webui-react/alert';
import {
  Demographic,
  AgeRanges,
  Genders,
  formatAgeRange,
  formatGender
} from '@bingads-webui-campaign-react/audience-demographic';

import { SectionShimmer } from './shimmer-element';

export const AudienceDemographics = React.memo(({
  isLoading,
  data,
  onDataChange,
  classes,
}) => {
  const i18n = useContext(I18nContext);

  const { ageRanges = [], genderTypes = [] } = data || {};

  const onChangeAgeTypes = useCallback(newAgeRanges => onDataChange({ ageRanges: newAgeRanges }), [onDataChange]);
  const onChangeGenderTypes = useCallback(newGenderTypes => (
    onDataChange({ genderTypes: newGenderTypes })
  ), [onDataChange]);

  if (isLoading) {
    return <SectionShimmer />;
  }

  return (
    <div className={classNames('audience-signal-demographic', classes.demographicsContainer)}>
      <Alert
        level="Info"
        dismissible={false}
        icon={(<FontIcon iconName="Lightbulb" />)}
        message={i18n.getString(_TL_('We recommend you leave demographics set broadly, but you can adjust here.'))}
      />
      <Demographic
        className="age-ranges-section"
        i18n={i18n}
        title={i18n.getString(_TL_('Age'))}
        description={i18n.getString(_TL_('Show your ads to people in these age ranges'))}
        dimensions={ageRanges}
        formatter={formatAgeRange}
        availableDimensions={AgeRanges}
        onChangeDimensions={onChangeAgeTypes}
        popupId="pop_BA_PMAX_Targeting_Age"
      />
      <Demographic
        className="genders-section"
        i18n={i18n}
        title={i18n.getString(_TL_('Gender'))}
        description={i18n.getString(_TL_('Show your ads to people in these gender groups'))}
        dimensions={genderTypes}
        formatter={formatGender}
        availableDimensions={Genders}
        onChangeDimensions={onChangeGenderTypes}
        popupId="pop_BA_PMAX_Targeting_Gender"
      />
    </div>
  );
});

AudienceDemographics.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.shape({}).isRequired,
  onDataChange: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    demographicsContainer: PropTypes.string.isRequired,
  }).isRequired,
};

AudienceDemographics.defaultProps = {};
